import { FiX } from "react-icons/fi";

interface DialogCloseButtonProps {
  onClose: () => void;
  className: string;
}

export const DialogCloseButton: React.FunctionComponent<
  DialogCloseButtonProps
> = ({ onClose, className }: DialogCloseButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClose}
      aria-label="閉じる"
      className={className}
    >
      <FiX className="w-5 h-5" aria-hidden="true" />
    </button>
  );
};
